import React, { useState } from 'react';
import './MemberAdd.css'; // Assuming the CSS file is in the same directory
import Select from 'react-select';
import DatePicker from "react-datepicker";
import Nav from "./../../components/SecureNav/Nav";
import "react-datepicker/dist/react-datepicker.css";

const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
];

const countryCodes = [
    { value: '+1', label: '+1 (USA)' },
    { value: '+44', label: '+44 (UK)' },
    { value: '+91', label: '+91 (IND)' },
    // Add more country codes as needed
];

const ImgUpload = ({ onChange, src }) => (
    <label htmlFor="photo-upload" className="custom-file-upload fas">
        <div className="img-wrap img-upload">
            <img src={src} alt="Preview" />
        </div>
        <input id="photo-upload" type="file" onChange={onChange} />
    </label>
);

const MemberAdd = () => {
    const [file, setFile] = useState('');
    const [imagePreviewUrl, setImagePreviewUrl] = useState('https://github.com/OlgaKoplik/CodePen/blob/master/profile.jpg?raw=true');
    const [formData, setFormData] = useState({
        userid: '26428',
        profile_pic: null,
        relationship: '',
        first_name: '',
        last_name: '',
        mobile: '',
        email: '',
        pettype: '',
        gender: 'M',
        is_living: true,
        dob: '',
        country_code: '+91',
    });

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : files ? files[0] : value,
        }));
    };

    const handleDateChange = (date) => {
        setFormData({ ...formData, dob: date });
    };

    const photoUpload = (e) => {
        e.preventDefault();
        const reader = new FileReader();
        const newFile = e.target.files[0];
        reader.onloadend = () => {
            setFile(newFile);
            setImagePreviewUrl(reader.result);
        };
        reader.readAsDataURL(newFile);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Add your submission logic here
    };

    return (
        <div>
            <Nav />

            <div className="col-12" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }} >
                <div className="row">
                    <div className="col-md-4" style={{ paddingTop: '20px' }} >
                        <ImgUpload onChange={photoUpload} src={imagePreviewUrl} />
                    </div>
                    <div className="col-md-8">
                        <form onSubmit={handleSubmit}>
                            <div className="inputBox">
                                <Select options={options} className="selectBox" placeholder="Select Relationship" id="relationship" name="relationship" />
                            </div>

                            <div className="inputBox">
                                <input
                                    type="text"
                                    className="first-name"
                                    id="first_name"
                                    name="first_name"
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    placeholder="First Name"
                                />
                            </div>

                            <div className="inputBox">
                                <input
                                    type="text"
                                    className="last-name"
                                    id="last_name"
                                    name="last_name"
                                    value={formData.last_name}
                                    placeholder="Last Name"
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="inputBox">
                                <div className="field">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <Select
                                                options={countryCodes}
                                                className="selectBox"
                                                placeholder="Country Code"
                                                id="country_code"
                                                name="country_code"
                                                value={countryCodes.find((code) => code.value === formData.country_code)}
                                                onChange={(selectedOption) => handleChange({
                                                    target: {
                                                        name: 'country_code',
                                                        value: selectedOption.value,
                                                    },
                                                })}
                                            />
                                        </div>
                                        <input
                                            style={{ paddingLeft: '10px' }}
                                            type="text"
                                            className="form-control mobile"
                                            id="mobile"
                                            name="mobile"
                                            value={formData.mobile}
                                            placeholder="Mobile"
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="inputBox">
                                <input
                                    type="email"
                                    className="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    placeholder="Email"
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="">
                                <label className="radio-btn-label">
                                    <span> Date of birth</span>
                                    <DatePicker
                                        selected={formData.dob}
                                        onChange={handleDateChange}
                                        dateFormat="dd/MM/yyyy"
                                        style={{ width: '100%' }}
                                    />
                                </label>

                                <label className="radio-btn-label">
                                    <span> Male</span>
                                    <input
                                        type="radio"
                                        className="radio"
                                        name="gender"
                                        id="gender_male"
                                        value="M"
                                        checked={formData.gender === 'M'}
                                        onChange={handleChange}
                                    />
                                    <i className="input-helper"></i>
                                </label>

                                <label className="radio-btn-label">
                                    <span> Female</span>
                                    <input
                                        type="radio"
                                        className="radio"
                                        name="gender"
                                        id="gender_female"
                                        value="F"
                                        checked={formData.gender === 'F'}
                                        onChange={handleChange}
                                    />
                                    <i className="input-helper"></i>
                                </label>

                                <label className="radio-btn-label">
                                    <span> Living</span>
                                    <input
                                        type="checkbox"
                                        className="form-input"
                                        name="is_living"
                                        id="is_living"
                                        checked={formData.is_living}
                                        onChange={handleChange}
                                    />
                                    <i className="input-helper"></i>
                                </label>
                            </div>

                            <div className="inputBox">
                                <button type="submit" className="btn btn-primary">
                                    SAVE
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div >

    );
};

export default MemberAdd;
